<template>
<div class="polar-scatter-chart-group">
  <div v-if="showHeader" class="polar-scatter-chart-group-header">
    <span>{{dataConfig.name}}</span>
  </div>

  <div class="polar-scatter-chart-group-body">
    <div
      v-for="data in formatDataList"
      :key="data.dimension.id"
      class="polar-scatter-chart-item"
    >
      <polar-scatter-chart :factor="data.dimension" :data="data.data" :unit-prop="unitProp" />
    </div>
  </div>
</div>
</template>

<script>
import PolarScatterChart from '../../../../../components/Data/PolarScatterChart'

export default {
  name: 'PolarScatterChartGroup',
  components: {PolarScatterChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formatDataList () {
      let {dimensions, dataTimes, seriesMap} = this.dataConfig
      dimensions = dimensions.filter(dimension => !/^101(2|3)$/.test(dimension.id))
      return dimensions.map(dimension => {
        let dimensionId = dimension.id
        let factorSeriesDataMap = seriesMap[dimensionId]
        let windSpeedSeriesDataMap = seriesMap['1012']
        let windDirSeriesDataMap = seriesMap['1013']

        return {
          dimension,
          data: {
            data: dataTimes.reduce((list, dataTime) => {
              dataTime = dataTime[1]

              let factorSeriesData = factorSeriesDataMap[dataTime]

              if (factorSeriesData) {
                let windSpeedData = windSpeedSeriesDataMap[dataTime]

                if (windSpeedData) {
                  let windDirSeriesData = windDirSeriesDataMap[dataTime]

                  if (windSpeedData) {
                    list.push({
                      [dimensionId]: {...factorSeriesData},
                      1012: {...windSpeedData},
                      1013: {...windDirSeriesData}
                    })
                  }
                }
              }

              return list
            }, [])
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.polar-scatter-chart-group {
  > .polar-scatter-chart-group-header {
    display: grid;
    grid-template-columns: auto max-content;
    line-height: 1.8em;
    padding: 0 10px;
    color: #ffffff;
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    font-weight: 600;
  }

  > .polar-scatter-chart-group-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    padding: 10px 0;

    > .polar-scatter-chart-item {
      flex: 0 0 470px;
      min-width: 0;
      height: 350px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/01Pollutant-Chart/PolarScatterChartGroup.vue